// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__LKPtS","colCheckbox":"styles_colCheckbox__1CPbc"};